export const BuyingLandAPMC = [
  {
    "fieldNo": "01.",
    "fieldName":"actionsByMarketingCommitee",
    "fieldVal": "બજાર સમિતિએ સરકારી જમીન મેળવવા કરેલ કામગીરીની વિગત (ટૂંકી નોંધ સહિત).Details of actions taken by the Market Committee to acquire government land, including a brief note.",
    "response": [
      { "responseType": "input", "responseVal": "marketCommitteeGovLandAction", "responseName": "Details of Actions Taken","fieldName":"actionsByMarketingCommitee", },
      { "responseType": "file", "responseVal": "marketCommitteeGovLandActionFile", "responseName": "Supporting Document","fieldName":"actionsByMarketingCommitee", }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldName":"marketingCommitteActionToAcquireGovtLand",
    "fieldVal": "સરકારી જમીન ઉપલબ્ધ નથી તે મુજબનું રેવન્યુ ઓથોરિટીનું પ્રમાણપત્ર (Certificate from the Revenue Authority stating that government land is not available.)",
    "response": [
      { "responseType": "file", "responseVal": "revAuthorityCertNoGovLand", "responseName": "Revenue Authority Certificate", "fieldName":"marketingCommitteActionToAcquireGovtLand" }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldName":"certificateOfRevenueAuthority",
    "fieldVal": "બજાર સમિતિની સાધારણ સભા/ખાસ સાધારણ સભાના ઠરાવથી આ બાબત નિર્ણય કરેલી હોવી જોઈએ. આ એજન્ડા/ઠરાવની પ્રમાણિત નકલ. આ અંગે કોઇનો વાંધો હોય તો તેની નકલ (બેઠકમાં રજૂ કરેલો ન હોય તો પણ) The matter must be resolved in a general/special meeting of the Market Committee. Attach a certified copy of the agenda/resolution. If any objection exists, a copy should also be included, even if it was not presented in the meeting.",
    "response": [
      { "responseType": "file", "responseVal": "marketCommResolutionAndObjections", "responseName": "Resolution and Objections","fieldName":"certificateOfRevenueAuthority" }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldName":"matterResolveByMarketCommitte",
    "fieldVal": "બજાર સમિતિ દ્વારા ગ્રામ્ય વિસ્તારની જમીન ખરીદવામાં આવે તો નમૂના ૬, ૮-અ અને ૭/૧૨ના તાજેતરના ઉતારા અને શહેરી વિસ્તાર માટે સીટી સર્વે કચેરીમાંથી પ્રોપર્ટી કાર્ડની નકલ (If rural land is purchased, provide recent copies of Forms 6, 8A, and 7/12. For urban land, include the property card issued by the City Survey Office.)",
    "response": [
      { "responseType": "file", "responseVal": "landOwnershipProofRuralUrban", "responseName": "Land Ownership Proof", "fieldName":"matterResolveByMarketCommitte" }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldName":"ruralLandCopyPurchased",
    "fieldVal": "સરકાર માન્ય વેલ્યુઅર પાસેથી જમીનના વેલ્યુએશન રિપોર્ટ, ટાઇટલ ક્લીયરન્સ રિપોર્ટ અને પ્લાન લે-આઉટની વિગતો તથા સર્ચ રિપોર્ટ (Land valuation report, title clearance report, plan layout details, and search report from a government-approved valuer.)",
    "response": [
      { "responseType": "file", "responseVal": "valuationReports", "responseName": "Valuation and Related Reports", "fieldName":"ruralLandCopyPurchased" }
    ]
  },
  {
    "fieldNo": "06.",
    "fieldName":"landEvaluationReportByGovt",
    "fieldVal": "સરકારશ્રીની જોગવાઈ મુજબ તે જમીનની સરકાર માન્ય જંત્રીની વિગત (Details of the government-approved Jantri rate for the land as per government norms.)",
    "response": [
      { "responseType": "file", "responseVal": "govtJantriRate", "responseName": "Jantri Rate Details", "fieldName":"landEvaluationReportByGovt" }
    ]
  },
  {
    "fieldNo": "07.",
    "fieldName":"govtApprovedJantriRate",
    "fieldVal": "જમીન મેળવવા અંગે વર્તમાનપત્રમાં આપેલ જાહેરાતની વિગત તથા અપનાવેલ ટેન્ડર પ્રક્રિયા અંગેની તમામ વિગત તેમજ ટેન્ડર પ્રક્રિયા દરમ્યાન જેના ભાવ નીચા આવેલ હોય તેની સાથે કરેલ નેગોશિએશનની તમામ કાર્યવાહી ની વિગત (Details of newspaper advertisements given for acquiring the land, full details of the tender process followed, and negotiations carried out with the lowest bidder.)",
    "response": [
      { "responseType": "file", "responseVal": "landAcquisitionTenderDetails", "responseName": "Tender and Negotiation Details", "fieldName":"govtApprovedJantriRate" }
    ]
  },
  {
    "fieldNo": "08.",
    "fieldName":"newspaperAdvertisementForLand",
    "fieldVal": " જમીન ખરીદી અંગે ઉપલબ્ધ ભંડોળ અને આયોજનની વિગત ( Details of available funds and budget planning for land purchase.)",
    "response": [
      { "responseType": "file", "responseVal": "fundsAndPlanning", "responseName": "Funds and Planning", "fieldName":"newspaperAdvertisementForLand" }
    ]
  },
  {
    "fieldNo": "09.",
    "fieldName":"detailsOfFundsAndBudget",
    "fieldVal": "જમીનની બજાર સમિતિને જરૂરિયાત છે, તેના કારણો તથા બજાર સમિતિને થનાર લાભ તથા આ જમીન પર ઉભી થનાર સુવિધાઓની વિગતો (Reasons for the Market Committee's need for the land, expected benefits, and details of facilities to be developed on the land.)",
    "response": [
      { "responseType": "file", "responseVal": "landNeedAndBenefits", "responseName": "Need, Benefits and Facilities", "fieldName":"detailsOfFundsAndBudget" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName":"detailOfLandOwnedByMarketingCommittee",
    "fieldVal": "બજાર સમિતિ પાસે હાલ ઉપલબ્ધ તમામ જમીનની વિગતો. (Details of all land currently owned by the Market Committee).",
    "response": [
      { "responseType": "file", "responseVal": "currentLandDetails", "responseName": "Current Land Details", "fieldName":"detailOfLandOwnedByMarketingCommittee" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName":"reasonOfMarketingCommitteeLand",
    "fieldVal": "જે જમીન બજાર સમિતિ ખરીદી રહી છે તે જમીન હાલના માલિકે તે પહેલા કોની પાસેથી ખરીદી હતી? કેટલી કિંમતમાં, કેટલા સમય પહેલા ખરીદાઈ હતી? તેની વિગતો. (ઈન્ડેક્ષ) (Details of the land's previous ownership before the current seller: from whom it was purchased, at what price, and when. Include the index.)",
    "response": [
      { "responseType": "file", "responseVal": "previousOwnershipDetails", "responseName": "Previous Ownership Details", "fieldName":"reasonOfMarketingCommitteeLand" }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName":"certificateOfNoCourtCaseFromMarketCommittee",
    "fieldVal": "સૂચિત જમીન અંગે કોઈ કોર્ટ કેસ (રેવન્યુ / જ્યુડિશિયલ) કેસ ચાલુ ન હોય તે અંગેનું બજાર સમિતિનું પ્રમાણપત્ર (Certificate from the Market Committee stating that there is no ongoing court case (revenue/judicial) related to the proposed land.)",
    "response": [
      { "responseType": "file", "responseVal": "noCourtCaseCertificate", "responseName": "No Court Case Certificate", "fieldName":"certificateOfNoCourtCaseFromMarketCommittee" }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName":"previousLandOwnershipDetails",
    "fieldVal": "જમીન/મિલકત વેચનાર વ્યક્તિ બજાર સમિતિના નિયામક મંડળના સભ્ય કે સંબંધી છે? બજાર સમિતિ સાથે પ્રત્યક્ષ કે પરોક્ષ રીતે સંકળાયેલ છે કે કેમ? તેની સ્પષ્ટ વિગતો (Clear details on whether the land/property seller is a member or relative of the Market Committee’s board, or has any direct or indirect association with the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "sellerRelationDetails", "responseName": "Seller Relationship Details", "fieldName":"previousLandOwnershipDetails" }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName":"incomeExpenditureAndFundStatements",
    "fieldVal": "બજાર સમિતિના છેલ્લાં ત્રણ વર્ષના આવક-જાવકના પત્રક, મહેકમ ખર્ચના પત્રક, તથા પાકા સરવૈયા (ઓડીટેડ) કાયમી ભંડોળના પત્રક રજૂ કરવા. ( Submit income-expenditure statements, administrative expense reports, and audited permanent fund statements for the last three years.)",
    "response": [
      { "responseType": "file", "responseVal": "financialStatements3Years", "responseName": "Financial Statements", "fieldName":"incomeExpenditureAndFundStatements" }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName":"balanceSheetAndAuditMemo",
    "fieldVal": " બજાર સમિતિના છેવટની તારીખના કાચા સરવૈયાની નકલ તથા છેલ્લો ઓડિટ મેમો. (Copy of the latest provisional balance sheet and the most recent audit memo of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "latestBalanceAndAudit", "responseName": "Balance Sheet and Audit Memo", "fieldName":"balanceSheetAndAuditMemo" }
    ]
  },
  {
    "fieldNo": "16.",
    "fieldName":"adminExpenseUndertaking",
    "fieldVal": "જમીન ખરીદ્યા બાદ બજાર સમિતિના વહીવટી ખર્ચ અને મહેકમ ખર્ચ યોગ્ય ધારાધોરણ – નિયમ મુજબ જળવાઈ રહેશે તેની બાંહેધરી. (Undertaking that the Market Committee’s administrative and operational expenses will be maintained as per applicable rules and standards after the land purchase.)",
    "response": [
      { "responseType": "file", "responseVal": "adminCostUndertaking", "responseName": "Administrative Cost Undertaking", "fieldName":"adminExpenseUndertaking" }
    ]
  },
  {
    "fieldNo": "17.",
    "fieldName":"profitabilityCertificate",
    "fieldVal": "બજાર સમિતિ નફો કરે છે તેવું બજાર સમિતિનું પ્રમાણપત્ર (Certificate from the Market Committee stating that it is operating profitably.)",
    "response": [
      { "responseType": "file", "responseVal": "profitCertificate", "responseName": "Profit Certificate", "fieldName":"profitabilityCertificate" }
    ]
  },
  {
    "fieldNo": "18.",
    "fieldName":"siteInspectionReportWithPhotos",
    "fieldVal": "ઉપરોક્ત તમામ બાબતો સાંકળી લેતો સહકારી અધિકારી (બજાર)નો સ્થળ તપાસ અહેવાલ. (રોજકામ ફોટોગ્રાફ સહ) (Site inspection report by the Co-operative Officer (Market) covering all the above matters, along with work photographs.)",
    "response": [
      { "responseType": "file", "responseVal": "siteInspectionReport", "responseName": "Inspection Report", "fieldName":"siteInspectionReportWithPhotos" }
    ]
  },
  {
    "fieldNo": "19.",
    "fieldName":"incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (અ/બ/ક/S) (Certificate of income-based classification of the Market Committee (A/B/C/S).)",
    "response": [
      { "responseType": "file", "responseVal": "classificationCertificate", "responseName": "Classification Certificate", "fieldName":"incomeClassificationCertificate" }
    ]
  }
];

export const SellingLandAPMC = [
  {
    "fieldNo": "01.",
    "fieldName":"certifiedMeetingResolutionCopy",
    "fieldVal": "જમીન/મકાન વેચાણ માટે બજાર સમિતિની સામાન્ય સભા/વિશેષ સામાન્ય સભાની એજન્ડાની પ્રમાણિત નકલ (Certified copy of the agenda of the general/special general meeting of the Market Committee for the sale of land/property.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agendaCertifiedCopy",
        "responseName": "Certified Agenda Copy",
        "fieldName":"certifiedMeetingResolutionCopy"
      }
    ]
  },
  {
    "fieldNo": "02.",
    "fieldName":"generalOrSpecialMeetingDecisionProof",
    "fieldVal": "બજાર સમિતિની સાધારણ સભા/ખાસ સાધારણ સભાના ઠરાવથી આ બાબત નિર્ણય કરેલી હોવી જોઈએ. આ ઠરાવની પ્રમાણિત નકલ. આ અંગે કોઇનો વાંધો હોય તો તેની નકલ (બેઠકમાં રજૂ કર્યો હોય તે સિવાય પણ). (The matter must be decided through a resolution of the general/special meeting of the Market Committee. Certified copy of the resolution. If there is any objection, attach a copy of it—even if it was not raised in the meeting.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "resolutionCertifiedCopy",
        "responseName": "Certified Resolution Copy",
        "fieldName":"generalOrSpecialMeetingDecisionProof"
      }
    ]
  },
  {
    "fieldNo": "03.",
    "fieldName":"detailsOfProposedLandOrProperty",
    "fieldVal": "વેચવાના રૂપરેખા ભુલકાસ્થળ / મકાનની જગ્યા સહિતની વિગત. (Details of the proposed land/house to be sold, including the location.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "proposedLandDetails",
        "responseName": "Proposed Land/House Details",
        "fieldName":"detailsOfProposedLandOrProperty"
      }
    ]
  },
  {
    "fieldNo": "04.",
    "fieldName":"justificationBenefitsAndFundUtilizationPlan",
    "fieldVal": "જમીન/મકાન વેચવાના વિષયની જરૂરિયાત છે તે અંગેની બજારસમિતિ તરફથી કરવામાં આવેલે વેચાણથી બજાર સમિતિને મળનારી રકમની વિવરણ અને ઉપલબ્ધ થનારી રકમનો ઉપયોગ ક્યાં ઉપયોગમાં લેશે તે અંગેની યોજના સહિતની વિગતો. (Justification for the need to sell the land by the Market Committee, expected benefits from such sale, and the planning for utilization of the generated funds.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "saleJustificationAndPlan",
        "responseName": "Justification and Utilization Plan",
        "fieldName":"justificationBenefitsAndFundUtilizationPlan"
      }
    ]
  },
  {
    "fieldNo": "05.",
    "fieldName":"originalPurchaseDetailsOfProperty",
    "fieldVal": "જે જમીન/મકાન વેચવા માંગે છે તે કેવી રીતે ખરીદાઈ હતી? (કિંમતે અને કેટલાં વર્ષે ખરીદવામાં આવી હતી?) તેની વિગતો તથા પુરાવા સંલગ્ન કરવા. (From whom was the land/property being sold by the Market Committee purchased? At what price, and how long ago? Provide full details and supporting documents.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "landPurchaseDetails",
        "responseName": "Original Purchase Details",
        "fieldName":"originalPurchaseDetailsOfProperty"
      }
    ]
  },
  {
    "fieldNo": "06.",
    "fieldName":"ownershipDocumentsAndPropertyCard",
    "fieldVal": "બજાર સમિતિ દ્વારા જમીન વેચાણ માટે લેખિત નિમિષ પત્રક જમીન/મકાનની માલિકી દાખલ દાખલા – ફોર્મ નં. ૬બી, ૭/૧૨ તથા શહેર નકશા અધિકારીની મિલ્કત કાર્ડની નકલ જરૂરી રહેશે. (For the sale of immovable property, submit copies of ownership documents—Form 6 B, 7/12—as well as the official property card from the City Survey Office.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "ownershipDocuments",
        "responseName": "Ownership Proof Documents",
        "fieldName":"ownershipDocumentsAndPropertyCard"
      }
    ]
  },
  {
    "fieldNo": "07.",
    "fieldName":"titleClearanceAndSearchReport",
    "fieldVal": "બજાર સમિતિ જે જમીન વેચવા માંગે છે તે માટે સરકારી માન્યકતાપામેલ રજિસ્ટર્ડ એડવોકેટ દ્વારા ટાઈટલ ક્લિયરન્સ સર્ટિફિકેટ તથા સર્ચ રિપોર્ટ સંલગ્ન કરવા. (Title clearance certificate and search report for the land being sold, issued by a government-approved panel advocate.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "titleClearanceAndSearchReport",
        "responseName": "Title Clearance and Search Report",
        "fieldName":"titleClearanceAndSearchReport"
      }
    ]
  },
  {
    "fieldNo": "08.",
    "fieldName":"layoutPlanAndValuationReport",
    "fieldVal": "સરકારી માન્ય મૂલ્યાંકન પત્રક ધરાવતી જમીન/મકાનનો પ્લાન (નકશો) તથા મૂલ્યાંકન રિપોર્ટ. (Layout plan (map) and valuation report of the land/property from a government-approved valuer.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "layoutAndValuationReport",
        "responseName": "Layout Map and Valuation Report",
        "fieldName":"layoutPlanAndValuationReport"
      }
    ]
  },
  {
    "fieldNo": "09.",
    "fieldName":"governmentApprovedJantriDetails",
    "fieldVal": "સરકારની મંજૂરીવાળી જાંહેર્લ કરેલી જમીન/મકાનની વિગતો. (Government-approved Jantri rate details of the land/property as per official provisions.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "jantriRateDetails",
        "responseName": "Government Jantri Rate Details",
        "fieldName":"governmentApprovedJantriDetails"
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName":"detailOfLandOwnedByMarketingCommittee",
    "fieldVal": "સરકારની મંજૂરી માટે જમીન/મકાન વિરુદ્ધ કોઈ કેસ/જમીન વિવાદ ન હોવાનો બજાર સમિતિ તરફથી દાખલ કરાયેલ પ્રમાણપત્ર. (Certificate from the Market Committee stating that the land/property to be sold is not under any (revenue/civil) court case or dispute.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "noCourtCaseCertificate",
        "responseName": "No Court Case Certificate",
        "fieldName":"detailOfLandOwnedByMarketingCommittee"
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName":"nonLitigationOrDisputeCertificate",
    "fieldVal": "બજાર સમિતિના છેલ્લા ત્રણ વર્ષના ખર્ચા-હિસાબનાં પત્રક, વહીવટી ખર્ચ પત્રક, તથા પक्का હિસાબ (ઓડિટેડ) પત્રક સંલગ્ન કરવા. (Submit the Market Committee’s income-expenditure statements, administrative expense sheets, and audited permanent fund statements for the last three years.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "lastThreeYearStatements",
        "responseName": "Last 3 Years Financials",
        "fieldName":"nonLitigationOrDisputeCertificate"
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName":"lastThreeYearsIncomeExpenditureStatements",
    "fieldVal": "બજાર સમિતિ ફાઈનાન્સ વિભાગ દ્વારા આપવામાં આવેલ નવો તથા તાજેતરનો બેલેન્સ મેમો. (Copy of the latest provisional balance sheet and the most recent audit memo of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "latestBalanceMemo",
        "responseName": "Latest Balance Memo",
        "fieldName":"lastThreeYearsIncomeExpenditureStatements"
      }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName":"fundUtilizationUndertakingAfterSale",
    "fieldVal": "જમીન/મકાનના વેચાણથી મળેલી રકમનો બજાર સમિતિ માટે ઉપયોગી રીતે તથા નિયમો પ્રમાણે ઉપયોગ થાશે તે અંગેનો બજાર સમિતિનો હસ્તાક્ષર કરાયેલ ઉતાર વિનંતી પત્ર. (Undertaking that the funds generated from the sale will be used in a manner beneficial to the Market Committee and strictly as per applicable norms/rules.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "fundUsageUndertaking",
        "responseName": "Fund Usage Undertaking",
        "fieldName":"fundUtilizationUndertakingAfterSale"
      }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName":"siteInspectionReportWithPhotographs",
    "fieldVal": "ઉપયોગ થયેલ તમામ દસ્તાવેજોનો સહીત સહાયક સંયુક્ત સંસ્થાના અધિકારીનો સાઇટ ઇન્સ્પેક્શન રિપોર્ટ. (સહાયક સંયુક્ત સંસ્થાના અધિકારી) (Site inspection report by the Co-operative Officer (Market) covering all of the above aspects, along with work photographs.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "siteInspectionReport",
        "responseName": "Site Inspection Report with Photos",
        "fieldName":"siteInspectionReportWithPhotographs"
      }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName":"incomeBasedClass",
    "fieldVal": "બજાર સમિતિનો આયક આધારિત વર્ગીકરણ પ્રમાણપત્ર (વર્ગ એ, બી, સી, ડી) (Income-based classification certificate of the Market Committee (Category A, B, C, or D).)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "incomeBasedClassification",
        "responseName": "Income Based Classification Certificate",
        "fieldName":"incomeBasedClass"
      }
    ]
  }
];
export const AgriProductsAPMC = [
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં (Original proposal of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "originalProposalFile", "responseName": "Original Proposal", "fieldName": "originalProposal" }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutions",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolutions of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "agendaFile", "responseName": "Agenda & Resolutions", "fieldName": "agendaResolutions" }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "commodityInfo",
    "fieldVal": "બજાર સમિતિ દ્વારા નિયમનમાં ઉમેરવા નક્કી કરવામાં આવેલ જણસીનું નામ, એપીએમસી એક્ટમાં સદર જણસીનો સમાવેશ છે કે કેમ? (Name of the commodity decided to be added under regulation by the Market Committee, and whether it is included under the APMC Act)",
    "response": [
      { "responseType": "input", "responseVal": "commodityName", "responseName": "Commodity Name", "fieldName": "commodityInfo" },
      { "responseType": "radio", "responseVal": "includedInAPMCAct", "responseName": "Included in APMC Act", "options": ["Yes", "No"] , "fieldName": "commodityInfo" }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "licenseDetails",
    "fieldVal": "બજાર સમિતિના છેલ્લા વર્ષના રોજ પુરા થતા વર્ષના લાયસન્સદારોની વિગત દર્શાવતું પત્રક. (Statement showing the details of license holders for the last completed financial year of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "licenseStatement", "responseName": "License Holders Statement", "fieldName": "licenseDetails" }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "regulatedCommodityStats",
    "fieldVal": "બજાર સમિતિમાં નિયંત્રિત કરેલ જણસીની માહિતી તથા છેલ્લા ત્રણ વર્ષની નિયંત્રણ જણસીઓની માર્કેટયાર્ડમાં કરેલ કુલ આવક દર્શાવતું પત્રક. (Details of regulated commodities by the Market Committee and a statement showing the total market yard arrivals of such commodities for the last three years)",
    "response": [
      { "responseType": "file", "responseVal": "regulatedCommoditiesStats", "responseName": "Regulated Commodity Stats (3 Years)", "fieldName": "regulatedCommodityStats" }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "financialStatements",
    "fieldVal": "બજાર સમિતિના છેલ્લા ત્રણ વર્ષના તારીજ, સરવૈયાની નકલ. (Copy of audited financial statements of the Market Committee for the last three years)",
    "response": [
      { "responseType": "file", "responseVal": "financialStatementsFile", "responseName": "Audited Financial Statements", "fieldName": "financialStatements" }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "notifications",
    "fieldVal": "સંબંધિત બજાર સમિતિ જાહેર કર્યાના અને તે પછીના આધારભૂત જાહેરનામા. (Notifications related to the declaration of the concerned Market Committee and subsequent relevant notifications)",
    "response": [
      { "responseType": "file", "responseVal": "declarationNotifications", "responseName": "Declaration Notifications", "fieldName": "notifications" }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "agricultureOfficerCertificate",
    "fieldVal": "સંબંધિત બજાર વિસ્તારના સૂચિત નિયંત્રિત જણસીના વાવેતર અને ઉત્પાદનના આંકડા દર્શાવતું ખેતીવાડી અધિકારીશ્રીનું પ્રમાણપત્ર (Certificate from the Agricultural Officer showing the sowing and production statistics of the proposed regulated commodity in the concerned market area)",
    "response": [
      { "responseType": "file", "responseVal": "agricultureOfficerCert", "responseName": "Agricultural Officer Certificate", "fieldName": "agricultureOfficerCertificate" }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "bilingualNotification",
    "fieldVal": "પ્રસિધ્ધ કરવાના થતા જાહેરનામાંની સૂચિત ગુજરાતી અને અંગ્રેજી નકલ. (Proposed Gujarati and English copies of the notification to be published)",
    "response": [
      { "responseType": "file", "responseVal": "notificationGujarati", "responseName": "Gujarati Notification Copy" , "fieldName": "bilingualNotification" },
      { "responseType": "file", "responseVal": "notificationEnglish", "responseName": "English Notification Copy", "fieldName": "bilingualNotification" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "villageCount",
    "fieldVal": "બજાર સમિતિના બજાર વિસ્તારના ગામોની સંખ્યા. (Number of villages in the market area of the Market Committee)",
    "response": [
      { "responseType": "input", "responseVal": "villageCountInput", "responseName": "Number of Villages", "fieldName": "villageCount" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "agricultureLandDetails",
    "fieldVal": "બજાર વિસ્તારની ખેતી વિષયક જમીનની વિગત. (Details of agricultural land in the market area)",
    "response": [
      { "responseType": "file", "responseVal": "agricultureLandFile", "responseName": "Agricultural Land Details", "fieldName": "agricultureLandDetails" }
    ]
  }
];
export const YardAPMC=[
  {
    "fieldNo": "1.",
    "fieldName": "originalProposalSigned",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં ચેરમેન અને સેક્રેટરીની સહી સાથે. (Original proposal of the Market Committee with the signatures of the Chairman and Secretary)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "originalProposalFile",
        "responseName": "Original Proposal with Signatures",
        "fieldName": "originalProposalSigned"
      }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutions",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ. (Certified copy of the Market Committee's agenda and resolutions)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agendaFile",
        "responseName": "Agenda and Resolutions",
        "fieldName": "agendaResolutions"
      }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "landExtracts",
    "fieldVal": "સૂચિત જમીનના ૭/૧૨, ૮અ ના તમામ ઉતારા. (All 7/12 and 8A land extracts of the proposed land)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "landExtractsFile",
        "responseName": "7/12 & 8A Extracts",
        "fieldName": "landExtracts"
      }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "govtLandOrder",
    "fieldVal": "સરકારની જમીન ફાળવણી અંગે કરેલ હોય તો હુકમની નકલ. (Copy of the government order, if land allotment has been made by the government)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "govtOrderFile",
        "responseName": "Government Land Order",
        "fieldName": "govtLandOrder"
      }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "facilityPlanning",
    "fieldVal": "બજાર સમિતિ ખાતે ખેડૂતો તથા વેપારીઓ માટે ઉભી કરવામાં આવનાર સુવિધાઓનું આયોજન પત્રક. (Planning document for facilities to be established by the Market Committee for farmers and traders)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "facilityPlanFile",
        "responseName": "Facility Planning Document",
        "fieldName": "facilityPlanning"
      }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "licenseDetails",
    "fieldVal": "બજાર સમિતિના છેલ્લા વર્ષના રોજ પુરા થતા વર્ષના લાયસન્સદારોની વિગત દર્શાવતું પત્રક. (Statement showing details of license holders for the last completed financial year of the Market Committee)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "licenseDetailsFile",
        "responseName": "License Holder Statement",
        "fieldName": "licenseDetails"
      }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "regulatedCommodities",
    "fieldVal": "બજાર સમિતિમાં નિયંત્રિત કરેલ જણસીની માહિતી તથા છેલ્લા ત્રણ વર્ષની નિયંત્રણ જણસીઓની માર્કેટયાર્ડમાં કરેલ કુલ આવક દર્શાવતું પત્રક. (Details of commodities regulated by the Market Committee and a statement showing total arrivals of such commodities in the market yard over the last three years)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "regulatedCommoditiesFile",
        "responseName": "Regulated Commodities & Arrivals",
        "fieldName": "regulatedCommodities"
      }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "bilingualNotification",
    "fieldVal": "પ્રસિધ્ધ કરવાના થતા જાહેરનામાંની ચતુઃદિશા સૂચિત ગુજરાતી અને અંગ્રેજી નકલ. (Proposed Gujarati and English versions of the notification to be published in all four directions)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "notificationGujarati",
        "responseName": "Gujarati Notification Copy",
        "fieldName": "bilingualNotification"
      },
      {
        "responseType": "file",
        "responseVal": "notificationEnglish",
        "responseName": "English Notification Copy",
        "fieldName": "bilingualNotification"
      }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "villageCount",
    "fieldVal": "બજાર સમિતિના બજાર વિસ્તારના ગામોની સંખ્યા. (Number of villages in the market area of the Market Committee)",
    "response": [
      {
        "responseType": "input",
        "responseVal": "villageCountInput",
        "responseName": "Number of Villages",
        "fieldName": "villageCount"
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "auditReports",
    "fieldVal": "બજાર સમિતિના છેલ્લા ત્રણ વર્ષના તારીજ, સરવૈયાની નકલ. (Copies of the audit reports of the Market Committee for the last three years)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "auditReportsFile",
        "responseName": "Audit Reports (3 Years)",
        "fieldName": "auditReports"
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "layoutPlan",
    "fieldVal": "મુખ્યયાર્ડ / સબયાર્ડની જમીન બાબતેના લે-આઉટ પ્લાનની નકલ. (Copy of the layout plan of the land for the main yard/sub-yard)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "layoutPlanFile",
        "responseName": "Layout Plan",
        "fieldName": "layoutPlan"
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "naPermission",
    "fieldVal": "મુખ્યયાર્ડ / સબયાર્ડની જમીન અંગે મેળવેલ એન.એ..(બિનખેતી)ની પરવાનગીની નકલ. (Copy of the N.A. (non-agricultural) permission obtained for the land of the main yard/sub-yard)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "naPermissionFile",
        "responseName": "N.A. Permission Copy",
        "fieldName": "naPermission"
      }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "notifications",
    "fieldVal": "સંબંધિત બજાર સમિતિ જાહેર કર્યાના અને તે પછીના અનુસંગિક જાહેરનામાં. (Notification of declaration of the concerned Market Committee and subsequent related notifications)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "notificationsFile",
        "responseName": "Related Notifications",
        "fieldName": "notifications"
      }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "mainYardDetails",
    "fieldVal": "બજાર સમિતિના મુખ્યયાર્ડની વિગત, ઉપલબ્ધ જમીન. (Details of the Market Committee's main yard and available land)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "mainYardDetailsFile",
        "responseName": "Main Yard Details",
        "fieldName": "mainYardDetails"
      }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName": "subyardDetails",
    "fieldVal": "બજાર સમિતિનું અન્ય કોઈ સબયાર્ડ કાર્યરત હોય તો તેની વિગત. (Details of any other sub-yard operated by the Market Committee, if applicable)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "subyardDetailsFile",
        "responseName": "Other Sub-yard Details",
        "fieldName": "subyardDetails"
      }
    ]
  }
];
export const AppointmentSecretaryAPMC = [
  {
    "fieldNo": "1.",
    "fieldName": "originalProposalOnly",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં. (Original proposal of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "originalProposalOnlyFile",
        "responseName": "Original Proposal",
        "fieldName": "originalProposalOnly"
      }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaAndResolutions",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolutions of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agendaAndResolutionsFile",
        "responseName": "Agenda & Resolutions",
        "fieldName": "agendaAndResolutions"
      }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "appointeeMedicalCertificate",
    "fieldVal": "નિમણૂક થનારનું નામ, શૈક્ષણિક લાયકાત, શારીરિક રીતે યોગ્ય હોવા બાબતનું સીવીલ સર્જનનું પ્રમાણપત્ર. (Name of the appointee, educational qualifications, and a medical fitness certificate from a civil surgeon.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "medicalCertificateFile",
        "responseName": "Appointee Certificate & Fitness",
        "fieldName": "appointeeMedicalCertificate"
      }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "characterCertificate",
    "fieldVal": "ચાલ ચલગત અને વર્તુણુંક અંગેનું પ્રમાણપત્ર (Character and conduct certificate.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "characterCertFile",
        "responseName": "Character Certificate",
        "fieldName": "characterCertificate"
      }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "policeClearance",
    "fieldVal": "ભારતીય ફોજદારી અધિનિયમ હેઠળ કોઈ ગુન્હો કે શિક્ષા થયેલ નથી તેવું સક્ષમ પોલીસ અધિકારીશ્રીનું પ્રમાણપત્ર. (Certificate from a competent police officer stating no offense or punishment under the Indian Penal Code.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "policeClearanceFile",
        "responseName": "Police Clearance Certificate",
        "fieldName": "policeClearance"
      }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "payScaleDetails",
    "fieldVal": "બજાર સમિતિના વર્ગ આધારિત મળવાપાત્ર સૂચિત પગારધોરણની વિગત (Details of the suggested pay scale applicable as per the category of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "payScaleFile",
        "responseName": "Pay Scale Details",
        "fieldName": "payScaleDetails"
      }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "directRecruitmentAd",
    "fieldVal": "સીધી ભરતીના કિસ્સામાં અગ્રગણ્ય વર્તમાનપત્રમાં આવેલ જાહેરાતની નકલ. (Copy of the advertisement published in a leading newspaper in case of direct recruitment.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "directRecruitmentAdFile",
        "responseName": "Recruitment Advertisement",
        "fieldName": "directRecruitmentAd"
      }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "recruitmentProcessProofs",
    "fieldVal": "સીધી ભરતીના કિસ્સામાં સેક્રેટરીશ્રીની પસંદગી માટે અપનાવવામાં આવેલ પ્રક્રિયા અને તેને સંલગ્ન આધારભૂત પુરાવા જેમ કે લેવામાં આવેલ રીઝલ્ટ શીટ, ઈન્ટરવ્યુની નકલ વગેરે. (Process adopted for the selection of the Secretary in case of direct recruitment and supporting documents such as result sheet, interview copy, etc.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "recruitmentProcessFile",
        "responseName": "Selection Process & Proofs",
        "fieldName": "recruitmentProcessProofs"
      }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "recruitmentPanelDetails",
    "fieldVal": "સીધી ભરતીના કિસ્સામાં સેક્રેટરીશ્રીની પસંદગી માટે બનાવવામાં આવેલ પેનલની વિગત. (Details of the panel formed for the selection of the Secretary in case of direct recruitment.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "recruitmentPanelFile",
        "responseName": "Selection Panel Details",
        "fieldName": "recruitmentPanelDetails"
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "agencyInvolvedProof",
    "fieldVal": "સીધી ભરતીના કિસ્સામાં જો એજન્સી રાખવામાં આવેલ હોય તો તેને સંલગ્ન આધારભૂત પુરાવા. (If an agency was appointed in the case of direct recruitment, related supporting evidence.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agencyProofFile",
        "responseName": "Agency Involvement Proof",
        "fieldName": "agencyInvolvedProof"
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "staffSchedule",
    "fieldVal": "બજાર સમિતિના સ્ટાફ શિડ્યુલની નકલ (Copy of the staff schedule of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "staffScheduleFile",
        "responseName": "Staff Schedule",
        "fieldName": "staffSchedule"
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "executiveMembersList",
    "fieldVal": "ચેરમેન, વાઈસ ચેરમેન તથા વર્તમાન વ્યવસ્થાપક સમિતિના સભ્યોની યાદી. (List of the Chairman, Vice Chairman, and current members of the Executive Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "executiveListFile",
        "responseName": "Executive Committee Members List",
        "fieldName": "executiveMembersList"
      }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "secretaryRelationsDetails",
    "fieldVal": "બજાર સમિતિના સેક્રેટરીશ્રી વ્યવસ્થાપક સમિતિના સભ્યો સાથે પ્રત્યક્ષ કે પરોક્ષ રીતે સંબંધ ધરાવે છે કે કેમ? તેની વિગત. (Details on whether the Secretary of the Market Committee has any direct or indirect relation with members of the Executive Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "secretaryRelationsFile",
        "responseName": "Secretary-Committee Relationship",
        "fieldName": "secretaryRelationsDetails"
      }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Statement showing details of income-expenditure, final accounts, permanent fund, and establishment expenses (with percentage) for the last three years.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "financialSummaryFile",
        "responseName": "Income-Expense Summary (3 Years)",
        "fieldName": "financialSummary"
      }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "classificationCertificate",
        "responseName": "Classification Certificate",
        "fieldName": "incomeClassificationCertificate"
      }
    ]
  }
];
export const PermAppointmentSecretaryAPMC=[
  {
    "fieldNo": "1.",
    "fieldName": "originalProposalCopy",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં. (Original proposal of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "originalProposalFile",
        "responseName": "Original Proposal",
        "fieldName": "originalProposalCopy"
      }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutionCopy",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolutions of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agendaResolutionsFile",
        "responseName": "Agenda & Resolutions",
        "fieldName": "agendaResolutionCopy"
      }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "temporaryAppointmentOrder",
    "fieldVal": "સેક્રેટરીશ્રીને અત્રેની કચેરી દ્વારા હંગામી નિમણૂકના હુકમની નકલ. (Copy of the temporary appointment order of the Secretary issued by this office.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "temporaryOrderFile",
        "responseName": "Temporary Appointment Order",
        "fieldName": "temporaryAppointmentOrder"
      }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "applicationForConfirmation",
    "fieldVal": "સેક્રેટરીશ્રી દ્વારા બજાર સમિતિને હંગામી નિમણૂકમાંથી કાયમી નિમણૂક મેળવવા કરેલ અરજીની નકલ (Copy of the application made by the Secretary to the Market Committee for converting temporary appointment to permanent.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "applicationForConfirmationFile",
        "responseName": "Application for Permanent Appointment",
        "fieldName": "applicationForConfirmation"
      }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "appointmentCertificate",
    "fieldVal": "સેક્રેટરી તરીકે નિમણૂક આપ્યાના કારણો તથા કામગીરી અંગેનું પ્રમાણપત્ર (Certificate stating reasons for appointment as Secretary and performance details.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "appointmentReasonCertFile",
        "responseName": "Appointment Reason & Performance Certificate",
        "fieldName": "appointmentCertificate"
      }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "trainingCertificate",
    "fieldVal": "સેક્રેટરીશ્રીએ પ્રોબેશન સમય દરમ્યાન ગુજરાત રાજ્ય કૃષિ બજાર બોર્ડની તાલીમ લીધાનું પ્રમાણપત્ર (Certificate of training received from Gujarat State Agricultural Market Board during probation period by the Secretary.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "trainingCertFile",
        "responseName": "Probation Training Certificate",
        "fieldName": "trainingCertificate"
      }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Statement showing income-expenditure, final accounts, permanent fund, and establishment expenses (with percentage) for the last three years.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "financialSummaryFile",
        "responseName": "Financial Statement (3 Years)",
        "fieldName": "financialSummary"
      }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "classificationCertFile",
        "responseName": "Income Classification Certificate",
        "fieldName": "incomeClassificationCertificate"
      }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "disciplinaryCertificate",
    "fieldVal": "હંગામી નિમણૂક દરમ્યાન બજાર સમિતિમાં દંડ કે શિક્ષાત્મક કાર્યવાહી થયેલ છે કે કેમ? તે અંગેનું પ્રમાણપત્ર (Certificate regarding whether any penalty or disciplinary action was taken during the temporary appointment in the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "disciplinaryActionFile",
        "responseName": "Disciplinary Action Certificate",
        "fieldName": "disciplinaryCertificate"
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "appointmentType",
    "fieldVal": "સેક્રેટરીશ્રીની નિમણૂક બઢતીથી થયેલ છે કે સીધી ભરતીથી? (Was the Secretary appointed through promotion or direct recruitment?)",
    "response": [
      {
        "responseType": "radio",
        "responseVal": "directRecruitment",
        "responseName": "Appointment Type",
        "fieldName": "appointmentType"
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "payScaleAndLastSalary",
    "fieldVal": "બજાર સમિતિના વર્ગ આધારિત મળવાપાત્ર સૂચિત પગાર ધોરણ તથા છેલ્લો પગાર. (Recommended pay scale based on category of the Market Committee and last drawn salary.)",
    "response": [
      {
        "responseType": "number",
        "responseVal": "recommendedPayScale",
        "responseName": "Recommended Pay Scale",
        "fieldName": "payScaleAndLastSalary"
      },
      {
        "responseType": "number",
        "responseVal": "lastDrawnSalary",
        "responseName": "Last Drawn Salary",
        "fieldName": "payScaleAndLastSalary"
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "committeeMembersList",
    "fieldVal": "બજાર સમિતિની ચેરમેન, વાઈસ ચેરમેન તથા વ્યવસ્થાપક કમિટીની યાદી. (List of the Chairman, Vice Chairman, and members of the Managing Committee of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "committeeListFile",
        "responseName": "Managing Committee List",
        "fieldName": "committeeMembersList"
      }
    ]
  }
];
export const AmendmentStaffMarketCommittee = [
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની રજુઆત અસલમાં (Original proposal of the Market Committee)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "originalProposalFile",
        "responseName": "Original Proposal",
        "fieldName": "originalProposal"
      }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutions",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolutions of the Market Committee)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agendaResolutionsFile",
        "responseName": "Agenda & Resolutions",
        "fieldName": "agendaResolutions"
      }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "approvedStaffSchedule",
    "fieldVal": "અગાઉ મંજૂર થયેલ સ્ટાફ શિડયુલ (Previously approved staff schedule)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "approvedStaffScheduleFile",
        "responseName": "Approved Staff Schedule",
        "fieldName": "approvedStaffSchedule"
      }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "draftStaffSchedule",
    "fieldVal": "મંજૂર કરવાના થતા સ્ટાફ શિડ્યુલનો મુસદ્દો (Draft of the staff schedule to be approved)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "draftStaffScheduleFile",
        "responseName": "Draft Staff Schedule",
        "fieldName": "draftStaffSchedule"
      }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "payScaleDetails",
    "fieldVal": "સૂચિત જગ્યા માટે લાગુ પડતા પગાર ધોરણ પત્રકની વિગતો (Details of the applicable pay scale for the proposed post)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "payScaleDetailsFile",
        "responseName": "Pay Scale Details",
        "fieldName": "payScaleDetails"
      }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "justificationForAmendment",
    "fieldVal": "સૂચિત સ્ટાફ શિડ્યુલમાં સુધારો કરવા અંગેનું જસ્ટીફીકેશન (Justification for making amendments in the proposed staff schedule)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "justificationAmendmentFile",
        "responseName": "Justification for Amendment",
        "fieldName": "justificationForAmendment"
      }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "formatCirculars",
    "fieldVal": "નિયત નમૂના ૧ થી 3 પરિપત્ર મુજબ (As per prescribed format 1 to 3 of the circular)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "circularFormatFile",
        "responseName": "Format 1 to 3 Circulars",
        "fieldName": "formatCirculars"
      }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "currentEmployeeCadreList",
    "fieldVal": "હાલ બજાર સમિતિમાં કાર્યરત કર્મચારીઓની કેડરવાઈઝ સંખ્યા/યાદી (Cadre-wise count/list of currently working employees in the Market Committee)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "cadreListFile",
        "responseName": "Cadre-wise Employee List",
        "fieldName": "currentEmployeeCadreList"
      }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "lastRecruitmentDetails",
    "fieldVal": "છેલ્લી ભરતીની વિગત (Details of the last recruitment)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "lastRecruitmentFile",
        "responseName": "Last Recruitment Details",
        "fieldName": "lastRecruitmentDetails"
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકા સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Statement showing details of income-expense, final accounts, permanent fund, and establishment expenditure (with percentage) of the last three years)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "financialSummaryFile",
        "responseName": "Financial Summary (3 Years)",
        "fieldName": "financialSummary"
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "expenseLimitUndertaking",
    "fieldVal": "અગાઉના વર્ષમાં થનાર આવક મુજબ, મહેકમ ખર્ચ ૪૦%ની મર્યાદામાં રહેશે તે અર્થેની બાંહેધરી (Undertaking that establishment expenses will remain within 40% of the income of the previous year)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "expenseLimitFile",
        "responseName": "Expense Limit Undertaking",
        "fieldName": "expenseLimitUndertaking"
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "provisionalAudit",
    "fieldVal": "બજાર સમિતિના છેવટની તારીખના કાચા સરવૈયાની નકલ તથા છેલ્લો ઓડિટ મેમો (Copy of the provisional balance sheet as on the last date of the Market Committee and the last audit memo)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "provisionalAuditFile",
        "responseName": "Provisional Balance Sheet & Last Audit Memo",
        "fieldName": "provisionalAudit"
      }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "classificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate of the Market Committee)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "classificationCertFile",
        "responseName": "Income Classification Certificate",
        "fieldName": "classificationCertificate"
      }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "employeeInquiry",
    "fieldVal": "બજાર સમિતિમાં હાલ ચાલુ કર્મચારી અથવા કર્મચારી ભરતી સામે કોઈ તપાસ ચાલુ છે કે કેમ? તેની વિગતો? તથા તપાસના કિસ્સામાં અગાઉ આ અર્થેની થયેલ કામગીરી. (Whether any inquiry is currently ongoing against any working employee or newly recruited employee in the Market Committee? Details of the same and any actions taken previously in such cases)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "employeeInquiryFile",
        "responseName": "Inquiry Details Document",
        "fieldName": "employeeInquiry"
      },
      {
        "responseType": "radio",
        "responseVal": "isInquiryOngoing",
        "responseName": "Is Inquiry Ongoing?",
        "fieldName": "employeeInquiry"
      }
    ]
  }
];
export const PromotionSecretaryMarketCommittee = [
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં. (Original proposal of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "originalProposalFile",
        "responseName": "Original Proposal",
        "fieldName": "originalProposal"
      }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutionCopy",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolution of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "agendaResolutionFile",
        "responseName": "Agenda & Resolution Copy",
        "fieldName": "agendaResolutionCopy"
      }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "promotionAppointmentResolution",
    "fieldVal": "સેક્રેટરીને બઢતીથી હંગામી નિમણૂક કર્યાના ઠરાવની પ્રમાણિત નકલ (Certified copy of the resolution for temporary appointment of Secretary through promotion.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "promotionResolutionFile",
        "responseName": "Promotion Appointment Resolution",
        "fieldName": "promotionAppointmentResolution"
      }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "promotionApplication",
    "fieldVal": "સેક્રેટરી તરીકે નિમણૂક મળવાની અરજીની નકલ સમગ્ર વિગતો સાથે (પ્રમોશન અરજી) (Copy of the application with complete details for appointment as Secretary (Promotion Application).)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "promotionApplicationFile",
        "responseName": "Promotion Application",
        "fieldName": "promotionApplication"
      }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "conductCertificate",
    "fieldVal": "ચાલ ચલગત અને વર્તુણૂક અંગેનું પ્રમાણપત્ર (Certificate regarding conduct and behavior.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "conductCertFile",
        "responseName": "Conduct Certificate",
        "fieldName": "conductCertificate"
      }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "experienceCertificate",
    "fieldVal": "બજાર સમિતિના અનુભવ અંગેનું પ્રમાણપત્ર (Certificate regarding experience in the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "experienceCertFile",
        "responseName": "Experience Certificate",
        "fieldName": "experienceCertificate"
      }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "disciplinaryCertificate",
    "fieldVal": "બજાર સમિતિમાં દંડ કે શિક્ષાત્મક કાર્યવાહી થયેલ છે કે કેમ? તે અંગેનું પ્રમાણપત્ર (Certificate regarding whether any penalty or disciplinary action has been taken in the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "disciplinaryCertFile",
        "responseName": "Disciplinary Action Certificate",
        "fieldName": "disciplinaryCertificate"
      }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "payScaleDetails",
    "fieldVal": "બજાર સમિતિના વર્ગ આધારિત મળવાપાત્ર સૂચિત પગારધોરણની વિગત (Details of suggested pay scale entitled as per class of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "payScaleDetailsFile",
        "responseName": "Pay Scale Details",
        "fieldName": "payScaleDetails"
      }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Statement showing income-expense, final balance sheet, permanent fund, and administrative expenses with percentage for the last three years.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "financialSummaryFile",
        "responseName": "Financial Summary (3 Years)",
        "fieldName": "financialSummary"
      }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "expenseLimitUndertaking",
    "fieldVal": "મહેકમ ખર્ચ મર્યાદા કરતાં નહીં વધે તે અંગેની બાંહેધરી (Undertaking that the administrative expenses will not exceed the prescribed limit.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "expenseLimitFile",
        "responseName": "Expense Limit Undertaking",
        "fieldName": "expenseLimitUndertaking"
      }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "staffScheduleCopy",
    "fieldVal": "બજાર સમિતિના સ્ટાફ શિડ્યુલની નકલ (Copy of the staff schedule of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "staffScheduleFile",
        "responseName": "Staff Schedule Copy",
        "fieldName": "staffScheduleCopy"
      }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "serviceRulesCopy",
    "fieldVal": "બજાર સમિતિના મંજૂર થયેલ સેવા નિયમની નકલ (Copy of the approved service rules of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "serviceRulesFile",
        "responseName": "Service Rules Copy",
        "fieldName": "serviceRulesCopy"
      }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "seniorityList",
    "fieldVal": "બજાર સમિતિના કર્મચારીઓની સિનિયોરીટીની યાદીનું પત્રક (Statement of the seniority list of Market Committee employees.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "seniorityListFile",
        "responseName": "Seniority List",
        "fieldName": "seniorityList"
      }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "noObjectionCertificate",
    "fieldVal": "બજાર સમિતિના કર્મચારીઓની સિનીયોરીટીની યાદી મુજબ સેક્રેટરી તરીકે બઢતી આપવા માટે સીનીયર કર્મચારીઓનું ના-વાંધા પ્રમાણપત્ર (No objection certificate from senior employees for promotion to Secretary as per the seniority list of Market Committee employees.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "nocFile",
        "responseName": "No Objection Certificate",
        "fieldName": "noObjectionCertificate"
      }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName": "recruitmentAndSalaryDetails",
    "fieldVal": "નિમણૂક મેળવનારની મૂળ ભરતી તથા હાલના પગારની વિગતો. (Details of the original recruitment and current salary of the appointee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "recruitmentSalaryFile",
        "responseName": "Recruitment & Salary Details",
        "fieldName": "recruitmentAndSalaryDetails"
      }
    ]
  },
  {
    "fieldNo": "16.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate of the Market Committee.)",
    "response": [
      {
        "responseType": "file",
        "responseVal": "classificationCertFile",
        "responseName": "Income Classification Certificate",
        "fieldName": "incomeClassificationCertificate"
      }
    ]
  }
];
export const ContractualAppointmentSecretaryAPMC = [
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં. (Original proposal of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "originalProposalFile", "responseName": "Original Proposal", "fieldName": "originalProposal" }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutions",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolutions of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "agendaResolutionFile", "responseName": "Agenda and Resolutions", "fieldName": "agendaResolutions" }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "contractAppointmentRequest",
    "fieldVal": "સેક્રેટરી / કર્મચારી દ્વારા કરાર આધારિત નિમણૂક આપવા بابتની રજુઆત (Request for contractual appointment of the Secretary/employee.)",
    "response": [
      { "responseType": "file", "responseVal": "contractAppointmentRequestFile", "responseName": "Contract Appointment Request", "fieldName": "contractAppointmentRequest" }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "appointmentOrderCopy",
    "fieldVal": "સેક્રેટરી / કર્મચારીને અત્રેથી નિમણૂક આપ્યાના હુકમની નકલ (Copy of the order of appointment issued to the Secretary/employee.)",
    "response": [
      { "responseType": "file", "responseVal": "appointmentOrderFile", "responseName": "Appointment Order Copy", "fieldName": "appointmentOrderCopy" }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "serviceHistory",
    "fieldVal": "સેક્રેટરી / કર્મચારીના સેવા ઈતિહાસની વિગત (Details of the service history of the Secretary/employee.)",
    "response": [
      { "responseType": "file", "responseVal": "serviceHistoryFile", "responseName": "Service History", "fieldName": "serviceHistory" }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "performanceCertificate",
    "fieldVal": "સેક્રેટરી / કર્મચારીને કરાર આધારિત નિમણૂક આપવા માટેના કારણો તથા તેઓશ્રીની કામગીરીનું પ્રમાણપત્ર (Reasons for contractual appointment and performance certificate.)",
    "response": [
      { "responseType": "file", "responseVal": "performanceCertFile", "responseName": "Performance Certificate", "fieldName": "performanceCertificate" }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "characterCertificate",
    "fieldVal": "સેક્રેટરી / કર્મચારીના ચાલ ચલગતનું સંસ્થાના ચેરમેનશ્રીનું પ્રમાણપત્ર (Character certificate by the Chairman.)",
    "response": [
      { "responseType": "file", "responseVal": "characterCertFile", "responseName": "Character Certificate", "fieldName": "characterCertificate" }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "medicalFitness",
    "fieldVal": "MBBS થી ઉતરતી કક્ષાના ન હોય તેવા ડૉક્ટરનું મેડીકલ ફિટનેસનું સર્ટીફિકેટ (Medical fitness certificate from qualified doctor.)",
    "response": [
      { "responseType": "file", "responseVal": "medicalFitnessFile", "responseName": "Medical Fitness Certificate", "fieldName": "medicalFitness" }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "disciplinaryCertificate",
    "fieldVal": "દંડ કે શિક્ષાત્મક કાર્યવાહી થયેલ છે કે કેમ? તે અંગેનું પ્રમાણપત્ર (Disciplinary certificate.)",
    "response": [
      { "responseType": "file", "responseVal": "disciplinaryFile", "responseName": "Disciplinary Certificate", "fieldName": "disciplinaryCertificate" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "complianceUndertaking",
    "fieldVal": "અત્રેની કચેરીના વખતોવખતના પરિપત્ર / સૂચનાઓનું પાલન કરવાની બાંહેધરી (Undertaking for circular/instruction compliance.)",
    "response": [
      { "responseType": "file", "responseVal": "complianceFile", "responseName": "Compliance Undertaking", "fieldName": "complianceUndertaking" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "salarySlips",
    "fieldVal": "સેક્રેટરી / કર્મચારીના છેલ્લા ત્રણ માસની પગાર સ્લીપ (Last 3 months’ salary slips.)",
    "response": [
      { "responseType": "file", "responseVal": "salarySlipFile", "responseName": "Last 3 Month Salary Slips", "fieldName": "salarySlips" }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "payScaleAndEstablishment",
    "fieldVal": "બજાર સમિતિના વર્ગ આધારિત મળવાપાત્ર સૂચિત પગારધોરણની વિગત તથા મહેકમખર્ચ વિગત (Suggested pay scale & establishment expense.)",
    "response": [
      { "responseType": "file", "responseVal": "payScaleEstablishmentFile", "responseName": "Pay Scale & Establishment", "fieldName": "payScaleAndEstablishment" }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "staffScheduleCopy",
    "fieldVal": "બજાર સમિતિના સ્ટાફ શિડ્યુલની નકલ (Staff schedule copy.)",
    "response": [
      { "responseType": "file", "responseVal": "staffScheduleFile", "responseName": "Staff Schedule", "fieldName": "staffScheduleCopy" }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Income-expense and financial details of last 3 years.)",
    "response": [
      { "responseType": "file", "responseVal": "financialSummaryFile", "responseName": "Financial Summary (3 Years)", "fieldName": "financialSummary" }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate.)",
    "response": [
      { "responseType": "file", "responseVal": "incomeClassCertFile", "responseName": "Income Classification Certificate", "fieldName": "incomeClassificationCertificate" }
    ]
  },
  {
    "fieldNo": "16.",
    "fieldName": "retirementDetails",
    "fieldVal": "સેક્રેટરી / કર્મચારીના નિવૃત્તિના હુકમની નકલ, નિવૃત્તિની તારીખ તથા ૬૨ (બાસઠ) વર્ષ પૂર્ણ થતા તારીખ (Retirement order, retirement date, and date of completing 62 years.)",
    "response": [
      { "responseType": "file", "responseVal": "retirementOrderFile", "responseName": "Retirement Order", "fieldName": "retirementDetails" },
      { "responseType": "date", "responseVal": "retirementDate", "responseName": "Retirement Date", "fieldName": "retirementDetails" },
      { "responseType": "date", "responseVal": "sixtyTwoCompletionDate", "responseName": "Date of Completing 62 Years", "fieldName": "retirementDetails" }
    ]
  }
];
export const PayComission=[
  {
    "fieldNo": "1.",
    "fieldName": "marketProposal",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત. (Market Committee's proposal.)",
    "response": [
      { "responseType": "file", "responseVal": "marketProposalFile", "responseName": "Market Committee Proposal", "fieldName": "marketProposal" }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolution",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolution of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "agendaResolutionFile", "responseName": "Agenda & Resolutions", "fieldName": "agendaResolution" }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "incomeClassification",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "incomeClassCertFile", "responseName": "Income Classification Certificate", "fieldName": "incomeClassification" }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકા સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Statement showing details of income-expenditure, audited accounts, permanent fund, and administrative expenses (with percentage) for the last three years.)",
    "response": [
      { "responseType": "file", "responseVal": "financialSummaryFile", "responseName": "3-Year Financial Summary", "fieldName": "financialSummary" }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "serviceRuleForm4",
    "fieldVal": "જિલ્લા રજિસ્ટ્રારનો સેવા નિયમ-૭ (નવો ફોર્મ નં.૪) (Service Rule-7 of the District Registrar (New Form No. 4).)",
    "response": [
      { "responseType": "file", "responseVal": "serviceRuleForm4File", "responseName": "Service Rule Form 4", "fieldName": "serviceRuleForm4" }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "permanentAppointmentOrder",
    "fieldVal": "સેક્રેટરીને કાય઼મી કરેલ હુકમ નકલ (Copy of the order for regular appointment of the Secretary.)",
    "response": [
      { "responseType": "file", "responseVal": "permanentAppointmentOrderFile", "responseName": "Permanent Appointment Order", "fieldName": "permanentAppointmentOrder" }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "sixthPayFixation",
    "fieldVal": "સેક્રેટરી / કર્મચારીનું છઠ્ઠા પગાર પંચ પ્રમાણે પગાર ફીકસેશનની નકલ તથા હાલના પગારની વિગત (Copy of pay fixation as per the Sixth Pay Commission for Secretary / employee and current salary details.)",
    "response": [
      { "responseType": "file", "responseVal": "sixthPayFixationFile", "responseName": "6th Pay Fixation & Salary Details", "fieldName": "sixthPayFixation" }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "basicPayCertificate",
    "fieldVal": "બેઝિક પે નું પ્રમાણપત્ર (Certificate of basic pay.)",
    "response": [
      { "responseType": "file", "responseVal": "basicPayCertFile", "responseName": "Basic Pay Certificate", "fieldName": "basicPayCertificate" }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "adminExpenseUndertaking",
    "fieldVal": "અગાઉના વર્ષમાં થનાર મહેકમ ખર્ચ આવકના ૪૦% કરતાં નહીં વધે તે અંગેની બાંહેધરી. (Undertaking that administrative expenses will not exceed 40% of income for the previous year.)",
    "response": [
      { "responseType": "file", "responseVal": "adminExpenseUndertakingFile", "responseName": "Administrative Expense Undertaking", "fieldName": "adminExpenseUndertaking" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "staffScheduleCopy",
    "fieldVal": "બજાર સમિતિના સ્ટાફ શિડ્યુલની નકલ (Copy of the Market Committee's staff schedule.)",
    "response": [
      { "responseType": "file", "responseVal": "staffScheduleFile", "responseName": "Staff Schedule Copy", "fieldName": "staffScheduleCopy" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "serviceBookCopy",
    "fieldVal": "સેક્રેટરીની servicપોથીની નકલ (પ્રથમ પેજ તથા જરૂરી નોંધોંની પ્રમાણીત) (Certified copy of the Secretary’s service book (first page and necessary remarks).)",
    "response": [
      { "responseType": "file", "responseVal": "serviceBookFile", "responseName": "Secretary Service Book", "fieldName": "serviceBookCopy" }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "seventhPayDetails",
    "fieldVal": "સાતમા પગારપંચ પ્રમાણે નિયત કરવાના થતા પગારની વિગત (Details of the salary to be fixed as per the Seventh Pay Commission.)",
    "response": [
      { "responseType": "file", "responseVal": "seventhPayDetailsFile", "responseName": "7th Pay Salary Details", "fieldName": "seventhPayDetails" }
    ]
  }
];
export const ProposalDonation=[
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની રજુઆત અસલમાં (Original proposal of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "originalProposalFile", "responseName": "Original Proposal", "fieldName": "originalProposal" }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolution",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolution of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "agendaResolutionFile", "responseName": "Agenda and Resolution", "fieldName": "agendaResolution" }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "donationRequestLetter",
    "fieldVal": "દાન મેળવવા માંગતી સંસ્થાનો પત્ર તથા ઠરાવ (પ્રમાણિત) (Letter and certified resolution of the institution requesting the donation)",
    "response": [
      { "responseType": "file", "responseVal": "donationRequestLetterFile", "responseName": "Donation Request Letter", "fieldName": "donationRequestLetter" }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "institutionConstitution",
    "fieldVal": "દાન માંગતી સંસ્થાનું બંધારણ તથા કામગીરીની ટૂંકી વિગતો (Constitution of the requesting institution and brief details of its activities)",
    "response": [
      { "responseType": "file", "responseVal": "institutionConstitutionFile", "responseName": "Institution Constitution", "fieldName": "institutionConstitution" }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "publicTrustCertificate",
    "fieldVal": "દાન માંગતી સંસ્થાનું પબ્લીક ટ્રસ્ટ હેઠળ નોંધણી થયાનું પ્રમાણપત્ર (Registration certificate of the requesting institution under Public Trust)",
    "response": [
      { "responseType": "file", "responseVal": "publicTrustCertFile", "responseName": "Public Trust Certificate", "fieldName": "publicTrustCertificate" }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "projectEstimatePurpose",
    "fieldVal": "પ્રોજેક્ટના પ્લાન્ટ એસ્ટીમેન્ટ તથા દાન હેતુની સ્પષ્ટતા (Project estimate and donation purpose clarification)",
    "response": [
      { "responseType": "file", "responseVal": "projectEstimateFile", "responseName": "Project Estimate & Purpose", "fieldName": "projectEstimatePurpose" }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "financialsLast3Years",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ (Income-expenditure, final accounts, and permanent fund details for the last 3 years)",
    "response": [
      { "responseType": "file", "responseVal": "financials3YearFile", "responseName": "3-Year Financial Details", "fieldName": "financialsLast3Years" }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "provisionalBalanceAudit",
    "fieldVal": "કાચા સરવૈયાની નકલ તથા છેલ્લો ઓડિટ મેમો (Provisional balance sheet and latest audit memo)",
    "response": [
      { "responseType": "file", "responseVal": "balanceAuditFile", "responseName": "Provisional Balance & Audit", "fieldName": "provisionalBalanceAudit" }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "termLoanDetails",
    "fieldVal": "મુદ્દત્વિતી લેણાં બાકી હોય તો વિગતો (Term loan details if any pending with Govt or bank)",
    "response": [
      { "responseType": "file", "responseVal": "loanDetailsFile", "responseName": "Term Loan Details", "fieldName": "termLoanDetails" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "donationEligibleFund",
    "fieldVal": "દાણ આપવાપાત્ર ભંડોળની વિગત (Details of donation-eligible fund)",
    "response": [
      { "responseType": "file", "responseVal": "donationEligibleFundFile", "responseName": "Donation-Eligible Fund", "fieldName": "donationEligibleFund" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "donationsGivenList",
    "fieldVal": "અત્યાર સુધી મંજૂર કરેલ દાનની યાદી (List of approved donations till date)",
    "response": [
      { "responseType": "file", "responseVal": "donationsListFile", "responseName": "Approved Donation List", "fieldName": "donationsGivenList" }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "governmentPurposeCertificate",
    "fieldVal": "ઠરાવની જોગવાઈ મુજબ હેતુ માટે છે તેવી વિગત / પ્રમાણપત્ર (Certificate that the purpose is as per Government resolution)",
    "response": [
      { "responseType": "file", "responseVal": "govPurposeCertFile", "responseName": "Govt Purpose Certificate", "fieldName": "governmentPurposeCertificate" }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "eligibleRemainingFund",
    "fieldVal": "બાકી રહેતા દેણગીપાત્ર ભંડોળની વિગત (Details of remaining donation-eligible fund after deductions)",
    "response": [
      { "responseType": "file", "responseVal": "remainingEligibleFundFile", "responseName": "Remaining Eligible Fund", "fieldName": "eligibleRemainingFund" }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "schoolTrustApproval",
    "fieldVal": "ટ્રસ્ટ શાળાના કિસ્સામાં શૈક્ષણિક મંજૂરી તથા દાનની વિગતો (Educational approval and donation details for trust-run schools)",
    "response": [
      { "responseType": "file", "responseVal": "schoolTrustFile", "responseName": "School Trust Approval", "fieldName": "schoolTrustApproval" }
    ]
  },
  {
    "fieldNo": "15.",
    "fieldName": "developmentFeeReceipts",
    "fieldVal": "છેલ્લાં ત્રણ વર્ષના વિકાસ ફાળાની પાવતી નકલો (Receipts of development contribution paid in last 3 years)",
    "response": [
      { "responseType": "file", "responseVal": "developmentReceiptsFile", "responseName": "Development Contribution Receipts", "fieldName": "developmentFeeReceipts" }
    ]
  },
  {
    "fieldNo": "16.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (અ/બ/ક/ડ) (Income classification certificate of the Market Committee (A/B/C/D))",
    "response": [
      { "responseType": "file", "responseVal": "incomeClassCertFile", "responseName": "Income Classification Certificate", "fieldName": "incomeClassificationCertificate" }
    ]
  }
];
export const ProposalLoan=[
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની રજુઆત અસલમાં (Original proposal of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "originalProposalFile", "responseName": "Original Proposal", "fieldName": "originalProposal" }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolution",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolution of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "agendaResolutionFile", "responseName": "Agenda and Resolution", "fieldName": "agendaResolution" }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "proposedWorkDetails",
    "fieldVal": "સૂચિત આયોજિત કામગીરીની વિગત (અંદાજિત ખર્ચ સહિત) (Details of the proposed planned work including estimated cost)",
    "response": [
      { "responseType": "file", "responseVal": "proposedWorkFile", "responseName": "Proposed Work Details", "fieldName": "proposedWorkDetails" }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "planEstimateDetails",
    "fieldVal": "સૂચિત આયોજિત કામગીરીના પ્લાન / એસ્ટિમેન્ટની વિગત (Details of the plan/estimate of the proposed planned work)",
    "response": [
      { "responseType": "file", "responseVal": "planEstimateFile", "responseName": "Plan/Estimate Details", "fieldName": "planEstimateDetails" }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "loanSchemeDetails",
    "fieldVal": "કઈ સ્કીમ હેઠળ લોન લેવા માંગે છે તેની વિગત (Details of the scheme under which the loan is to be taken)",
    "response": [
      { "responseType": "file", "responseVal": "loanSchemeFile", "responseName": "Loan Scheme Details", "fieldName": "loanSchemeDetails" }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "mortgageLandProof",
    "fieldVal": "તારણમાં મુકવાની જમીનની માલિકીના પુરાવા (Ownership documents of the land to be mortgaged)",
    "response": [
      { "responseType": "file", "responseVal": "landOwnershipFile", "responseName": "Land Ownership Proof", "fieldName": "mortgageLandProof" }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "availableLandFacilities",
    "fieldVal": "બજાર સમિતિ પાસે હાલ ઉપલબ્ધ તમામ જમીનની વિગતો તથા ઉપલબ્ધ સુવિધાઓની વિગત (Details of all the land currently available with the Market Committee and the available facilities)",
    "response": [
      { "responseType": "file", "responseVal": "landFacilitiesFile", "responseName": "Available Land & Facilities", "fieldName": "availableLandFacilities" }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "bankLoanDetails",
    "fieldVal": "જે બેંકમાંથી લોન લેવાની હોઈ તે બેંકનું નામ / વ્યાજદર / મુદતની વિગત / પત્રની નકલ (Bank name, interest rate, duration, letter copy)",
    "response": [
      { "responseType": "file", "responseVal": "bankLoanFile", "responseName": "Bank Loan Details", "fieldName": "bankLoanDetails" }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "loanRepaymentPlan",
    "fieldVal": "લોન કઈ રીતે અને કેટલા સમયમાં ભરપાઈ કરવામાં આવશે? તેની વિગતો (How and within what time the loan will be repaid? Details)",
    "response": [
      { "responseType": "file", "responseVal": "repaymentPlanFile", "responseName": "Loan Repayment Plan", "fieldName": "loanRepaymentPlan" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "repaymentUndertaking",
    "fieldVal": "નિયત સમયગાળામાં લોન ભરપાઈ થવા અંગે ચેરમેન - સેક્રેટરીની બાંહેધરી (Chairman-Secretary's commitment for repayment)",
    "response": [
      { "responseType": "file", "responseVal": "repaymentUndertakingFile", "responseName": "Repayment Undertaking", "fieldName": "repaymentUndertaking" }
    ]
  },
  {
    "fieldNo": "11.",
    "fieldName": "registrarCertificate",
    "fieldVal": "લોનની જરૂરીયાત અંગે જિલ્લા રજિસ્ટ્રારશ્રીનો સ્થળ તપાસ સહિતનું પ્રમાણપત્ર (District Registrar’s site inspection certificate regarding loan necessity)",
    "response": [
      { "responseType": "file", "responseVal": "registrarCertFile", "responseName": "Registrar Site Inspection Certificate", "fieldName": "registrarCertificate" }
    ]
  },
  {
    "fieldNo": "12.",
    "fieldName": "developmentContributionReceipts",
    "fieldVal": "બજાર સમિતિ દ્વારા છેલ્લા ત્રણ વર્ષનો વિકાસ ફાળો ગુજરાત રાજ્ય કૃષિ બજાર બોર્ડમાં ભરપાઈ કર્યા અંગેની પાવતીની નકલો (Receipts of development contribution paid in last three years)",
    "response": [
      { "responseType": "file", "responseVal": "developmentReceiptsFile", "responseName": "Development Contribution Receipts", "fieldName": "developmentContributionReceipts" }
    ]
  },
  {
    "fieldNo": "13.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Financial summary with percentage for the last three years)",
    "response": [
      { "responseType": "file", "responseVal": "financialSummaryFile", "responseName": "Financial Summary", "fieldName": "financialSummary" }
    ]
  },
  {
    "fieldNo": "14.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (Income-based classification certificate of the Market Committee)",
    "response": [
      { "responseType": "file", "responseVal": "incomeClassCertFile", "responseName": "Income Classification Certificate", "fieldName": "incomeClassificationCertificate" }
    ]
  }
];
export const StudyTour=[
  {
    "fieldNo": "1.",
    "fieldName": "originalProposal",
    "fieldVal": "બજાર સમિતિની દરખાસ્ત અસલમાં. (Original proposal of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "originalProposalFile", "responseName": "Original Proposal", "fieldName": "originalProposal" }
    ]
  },
  {
    "fieldNo": "2.",
    "fieldName": "agendaResolutionCopy",
    "fieldVal": "બજાર સમિતિના એજન્ડા તથા ઠરાવની પ્રમાણિત નકલ (Certified copy of the agenda and resolution of the Market Committee.)",
    "response": [
      { "responseType": "file", "responseVal": "agendaResolutionFile", "responseName": "Agenda and Resolution Copy", "fieldName": "agendaResolutionCopy" }
    ]
  },
  {
    "fieldNo": "3.",
    "fieldName": "studyTourBenefits",
    "fieldVal": "અભ્યાસ પ્રવાસ આયોજનથી થનાર લાભ (Benefits expected from the study tour planning.)",
    "response": [
      { "responseType": "file", "responseVal": "studyTourBenefitsFile", "responseName": "Benefits Document", "fieldName": "studyTourBenefits" },
      { "responseType": "input", "responseVal": "studyTourBenefitsText", "responseName": "Benefits Description", "fieldName": "studyTourBenefits" }
    ]
  },
  {
    "fieldNo": "4.",
    "fieldName": "tourProgramSchedule",
    "fieldVal": "સૂચિત અભ્યાસ પ્રવાસ કાર્યક્રમ / તારીખવાર (Proposed study tour program / date-wise details.)",
    "response": [
      { "responseType": "file", "responseVal": "tourProgramFile", "responseName": "Tour Program Schedule", "fieldName": "tourProgramSchedule" }
    ]
  },
  {
    "fieldNo": "5.",
    "fieldName": "financialSummary",
    "fieldVal": "છેલ્લા ત્રણ વર્ષના આવક-ખર્ચ, પાકાં સરવૈયા, કાયમી ભંડોળ તથા મહેકમ ખર્ચ (ટકાવારી સહ)ની વિગત દર્શાવતું પત્રક (Statement showing income-expenditure, final balance, permanent fund, and administrative expenses (with percentage) for the last three years.)",
    "response": [
      { "responseType": "file", "responseVal": "financialSummaryFile", "responseName": "3-Year Financial Summary", "fieldName": "financialSummary" }
    ]
  },
  {
    "fieldNo": "6.",
    "fieldName": "developmentReceipts",
    "fieldVal": "બજાર સમિતિ દ્વારા છેલ્લા ત્રણ વર્ષનો વિકાસ ફાળો ગુજરાત રાજ્ય કૃષિ બજાર બોર્ડમાં ભરપાઈ કર્યા અંગેની પાવતીની નકલો (Receipts for development contribution over the last three years.)",
    "response": [
      { "responseType": "file", "responseVal": "developmentReceiptsFile", "responseName": "Development Receipts", "fieldName": "developmentReceipts" }
    ]
  },
  {
    "fieldNo": "7.",
    "fieldName": "representativeList",
    "fieldVal": "પ્રવાસમાં જોડાનાર પ્રતિનિધિઓની યાદી અને સંખ્યા (List and number of representatives participating in the tour.)",
    "response": [
      { "responseType": "file", "responseVal": "representativeListFile", "responseName": "List of Representatives", "fieldName": "representativeList" }
    ]
  },
  {
    "fieldNo": "8.",
    "fieldName": "pastTourDetails",
    "fieldVal": "છેલ્લા પાંચ વર્ષમાં બજાર સમિતિએ કરેલ પ્રવાસની વિગત અને પ્રવાસનોંધની નકલ (Details of tours in last five years and tour note copy.)",
    "response": [
      { "responseType": "file", "responseVal": "pastTourDetailsFile", "responseName": "Past Tour Details", "fieldName": "pastTourDetails" }
    ]
  },
  {
    "fieldNo": "9.",
    "fieldName": "participantConsent",
    "fieldVal": "અભ્યાસ પ્રવાસમાં જનાર દરેક વ્યક્તિગત રીતે 25% રકમ જે-તે સભ્ય પાસેથી લેવા બાબતનું સંમતિપત્ર (Consent letter for collecting 25% of tour cost from each member.)",
    "response": [
      { "responseType": "file", "responseVal": "consentLetterFile", "responseName": "Consent Letter", "fieldName": "participantConsent" }
    ]
  },
  {
    "fieldNo": "10.",
    "fieldName": "incomeClassificationCertificate",
    "fieldVal": "બજાર સમિતિનું આવક આધારિત વર્ગીકરણનું પ્રમાણપત્ર (અ/બ/ક/S) (Income-based classification certificate of the Market Committee (A/B/C/S))",
    "response": [
      { "responseType": "file", "responseVal": "incomeClassCertFile", "responseName": "Income Classification Certificate", "fieldName": "incomeClassificationCertificate" }
    ]
  }
];